export default "__VITE_ASSET__35da0852__"